import React from "react";
import { Link } from "react-router-dom";

import Balloon from "../Others/balloon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

const CardBubble = (props) => {
    return (
        <div className={"card text-" + props.align}>
            <div className={"card-header border-0 pt-5 align-items-start justify-content-"+ props.align}>
                <Balloon color={props.colorIcon} icon={props.icon} className="mt-2"/>
            </div>

            <div className="card-body mt-3">
                <h4 className="card-title mb-2">{props.title}</h4>
                <p className="card-text">{props.description}</p>
            </div>

            <div className={"card-footer text-" + props.align}>
                {props.extLink && <a className="btn btn-link"
                    href={props.link}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <FontAwesomeIcon icon={faArrowRight} className={"mr-2 icon-" + props.colorIcon} />
                    {props.action}
                </a>}

                {!props.extLink && 
                    <Link to={props.link} className="btn btn-link"><FontAwesomeIcon icon={faArrowRight} className={"mr-2 icon-" + props.colorIcon} />{props.action}</Link>
                }

            </div>
        </div>
    );
}

CardBubble.defaultProps = {
    colorIcon: "blue",
    align: "left",
    extLink: false
}

export default (CardBubble);